<script setup lang="ts">
import type { ShipexkursTab } from '~~/types';
import type { GameVehicleSummary, WikiVehicle } from "~~/types/gamedata";

const props = defineProps({
  vehicle: {
    type: Object as () => GameVehicleSummary,
    required: true,
  },
  raw: {
    type: Object as () => WikiVehicle,
    required: true,
  },
});

const tabs = computed<ShipexkursTab[]>(() => [{
  label: 'Kapazität',
  icon: 'i-lucide-package',
  items: [{
    label: 'Mind. Crew',
    value: `${props.vehicle.crew.min}`,
  },{
    label: 'Max. Crew',
    value: `${props.vehicle.crew.max}`,
  },{
    label: 'Frachtkapazität',
    value: String(props.vehicle.cargo),
    suffix: 'SCU',
    icon: 'cargogrid',
  },{
    label: 'Größmögliche SCU-Box',
    value: props.raw?.cargo_limits?.max_scu_box ?? 0,
    suffix: 'SCU-Box',
    icon: 'container',
  },{
    label: 'Waffenschränke (Anzahl)',
    value: props.raw.weapon_storage?.lockers ?? 0,
    suffix: 'Schränke',
    icon: 'pistol-s38',
  },{
    label: 'Waffenschränke (Plätze)',
    value: `Handwaffen: ${props.raw.weapon_storage?.slots_pistol ?? 0} / Langwaffen: ${props.raw.weapon_storage?.slots_rifle ?? 0}`,
    icon: 'weapon',
  },
  ...(props.raw.suit_storage?.lockers ? [{
    label: 'Anzugschränke',
    value: props.raw.suit_storage?.lockers,
    suffix: 'Schränke',
    full: true,
  }] : [])],
}]);
</script>

<template>
  <ShipexkursShipTable :tabs="tabs" />
</template>
